import {fromJS, List} from 'immutable'

import {
  GROUP_CHAT_SCOPES,
  ROLES
} from '../../config/constants'

import {
  SET_CHAT_LIST_USER,
  REMOVE_CHAT_LIST_USER,
  CHANGE_CHAT_LIST_USER_ROLE,
  SET_CHAT_LIST_GUESTS,
  SET_CURRENT_USER,
  SET_RECENT_CONVERSATIONS,
  SET_RECENT_CONVERSATION_USER,
  SET_GROUP_CHATS,
  SET_GROUP_CHAT_ORDERS
} from '../action_types'

const CHAT_LIST_USER_SEGMENTS = {
  [ROLES.ADMIN]: 'admins',
  [ROLES.AUTHOR]: 'authors',
  [ROLES.EXPERT]: 'experts',
  [ROLES.PREMIUM]: 'users',
  [ROLES.USER]: 'users'
}

import orderGroupChats from '../helpers/order_group_chats'
import recentConversationsViewReducer from './recent_conversations_view_reducer'

const excludeCurrentUser = (segments = fromJS({}), uid) => {
  if (!uid) return segments

  return segments.map((segment) => segment.filter((user) => user.get('uid') !== uid))
}

const globalGroupChatReducer = (state = fromJS({}), action) => {
  let groups, orders

  switch (action.type) {
    case SET_GROUP_CHATS:
      groups = fromJS(action.groups)
      orders = state.get('orders')

      state = state.set('groups', groups)
      state = state.set('list', orderGroupChats(groups, orders))

      return state

    case SET_GROUP_CHAT_ORDERS:
      groups = state.get('groups')
      orders = fromJS(action.orders)

      state = state.set('orders', orders)
      state = state.set('list', orderGroupChats(groups,orders))

      return state

    default:
      return state
  }
}

const groupChatSegmentReducer = (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_GROUP_CHATS:
    case SET_GROUP_CHAT_ORDERS:
      state = state.set(
        'globals',
        globalGroupChatReducer(state.get('globals'), action)
      )

      state = state.set('list', state.getIn(['globals', 'list']))

      return state


    default:
      return List()
  }
}

const getSegmentByRole = (role) => CHAT_LIST_USER_SEGMENTS[role]

const userSegmentReducer = (state = fromJS([]), currentUserUid, action) => {
  const uid = action.user.get('uid')

  switch(action.type) {
    case SET_CHAT_LIST_USER:
      if (uid === currentUserUid) return state

      state = state
        .filter((a) => a.get('uid') !== uid)
        .filter((a) => a.get('uid') !== currentUserUid)
        .push(action.user.set('presence', action.presence))
        .sortBy((a) => -1 * a.get('presence'))

      return state

    case REMOVE_CHAT_LIST_USER:
      state = state
        .filter((a) => a.get('uid') !== uid)

      return state

    default:
      return state
  }
}

const chatListUserReducer = (state = fromJS({}), action) => {
  if (!action.user) return state

  const segment = getSegmentByRole(action.user.get('role'))

  switch(action.type) {
    case SET_CHAT_LIST_USER:
    case REMOVE_CHAT_LIST_USER:
      let segmentState = userSegmentReducer(
        state.getIn(['segments', segment]),
        state.get('_currentUserUid'),
        action
      )

      return state.setIn(['segments', segment], segmentState)

    case CHANGE_CHAT_LIST_USER_ROLE:
      const oldSegment = getSegmentByRole(action.prevRole)

      const newSegmentState = userSegmentReducer(
        state.getIn(['segments', segment]),
        state.get('_currentUserUid'),
        {...action, type: SET_CHAT_LIST_USER}
      )

      const oldSegmentState = userSegmentReducer(
        state.getIn(['segments', oldSegment]),
        state.get('_currentUserUid'),
        {...action, type: REMOVE_CHAT_LIST_USER}
      )

      return state
        .setIn(['segments', segment], newSegmentState)
        .setIn(['segments', oldSegment], oldSegmentState)

    default:
      return state
  }
}

export default (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_CHAT_LIST_USER:
    case REMOVE_CHAT_LIST_USER:
    case CHANGE_CHAT_LIST_USER_ROLE:
      state = chatListUserReducer(state, action)

      return state

    case SET_CHAT_LIST_GUESTS:
      return state.setIn(['segments', 'guests'], action.guests)

    case SET_CURRENT_USER:
      if (action.user) {
        state = state.set('_currentUserUid', action.user.uid)
      }
      else {
        state = state.delete('_currentUserUid')
      }
      state = state.set('segments', excludeCurrentUser(state.get('segments'), state.get('_currentUserUid')))

      return state

    case SET_RECENT_CONVERSATIONS:
    case SET_RECENT_CONVERSATION_USER:
      return state.setIn(
        ['segments', 'recents'],
        recentConversationsViewReducer(state.getIn(['segments', 'recents']), action)
      )

    case SET_GROUP_CHATS:
    case SET_GROUP_CHAT_ORDERS:
      if (action.scope === GROUP_CHAT_SCOPES.GLOBAL) {
        return state.setIn(
          ['segments', 'groups'],
          groupChatSegmentReducer(state.getIn(['segments', 'groups']), action)
        )
      }

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/chat_list_view.js
 **/